export var MAX_WIDTH = 215;